var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simplebar-scroll"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.scrolled)?_c('font-awesome-icon',{staticClass:"simplebar-scroll__icon",class:[
                         _vm.is_dark && _vm.current_of.themed_scrollbar ?
                           'simplebar-scroll__icon--inverted-color'
                           : 'simplebar-scroll__icon--default-color'
                       ],attrs:{"fixed-width":"","icon":"chevron-up"},on:{"click":_vm.scrollTop}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }